import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

window.navigatorPanel = new Vue({
  render: h => h(App)
});

console.log('window.navigatorPanel', window.navigatorPanel);
